// extracted by mini-css-extract-plugin
module.exports = {"backLink":"src-lib-app-containers-AuthenticatedNotification-style-module__backLink--2FWSu"};